export default defineNuxtRouteMiddleware(async (to, from) => {
  // skip middleware on server
  if (process.server) return

  const runtimeConfig = useRuntimeConfig()

  if (!runtimeConfig.public.isMaintenance) return
  const { $sdk, $normalizePath } = useNuxtApp()
  const account = await $sdk
    .module('auth')
    .then(({ getAccount }) => getAccount())

  if (to.path !== '/' && !account?.scopes?.includes('accessTesting')) {
    const redirectPath = $normalizePath('/')
    return navigateTo(redirectPath)
  }
})
